var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16V16.2887L15.75 16.433L21.3625 19.6734C21.1919 19.9224 21.0046 20.1587 20.802 20.3808C20.3537 20.8721 19.8308 21.2938 19.25 21.6292C18.2619 22.1997 17.141 22.5 16 22.5C14.859 22.5 13.7381 22.1997 12.75 21.6292C12.2868 21.3617 11.8605 21.0394 11.4794 20.6706C11.4254 20.6183 11.3723 20.5651 11.3201 20.5109C10.9552 20.1324 10.636 19.7093 10.3708 19.25C9.80034 18.2619 9.5 17.141 9.5 16C9.5 14.859 9.80034 13.7381 10.3708 12.75C10.6472 12.2714 10.9822 11.8321 11.3665 11.4415L11.0375 11.1178L11.3665 11.4415C11.3927 11.4148 11.4191 11.3884 11.4457 11.3623C11.8353 10.9797 12.2731 10.6462 12.75 10.3708C13.3308 10.0355 13.9575 9.79351 14.6071 9.65099C14.9008 9.58657 15.1991 9.54247 15.5 9.51926V16ZM22.3574 17.361L18 14.8453V9.81335C20.6114 10.6568 22.5 13.1084 22.5 16C22.5 16.4672 22.4508 16.9225 22.3574 17.361Z",
    stroke: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5e82b3b46a5c3f70e259c8af3b203e1a.svg";
export { ForwardRef as ReactComponent };